import React, { useEffect } from 'react';
export default function LegacyNotice() {
  useEffect(() => {
    let meta = document.head.querySelector('meta[name="robots"]');
    if (!meta) { meta = document.createElement('meta'); meta.name = 'robots'; document.head.appendChild(meta); }
    meta.content = 'noindex,follow';
  }, []);
  return <main style={{ background: '#103e40', color: '#fff', padding: '18px 24px', textAlign: 'center', position: 'relative', zIndex: 1500 }}>
    <h1 style={{ fontSize: '2rem', color: '#fff' }}>This concept site is archived.</h1>
    Legacy material is no longer promoted here. It does not describe the current FinnixPro product.{' '}
    <a href="https://www.finnixpro.com/product/overview" style={{ color: '#b5f2e2', textDecoration: 'underline' }}>Explore FinnixPro financial intelligence</a>.
  </main>;
}
